import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'

import BookingWidget from './bookingWidget/BookingWidget'

import './typography.css'

const targets = document.querySelectorAll(`[data-name*="react-widget"]`)

for (const target of targets) {
  const root = ReactDOM.createRoot(target)

  const type = target.getAttribute('data-type') || 'banner'

  root.render(
    <React.StrictMode>
      <div className={`redfunnel__${type}`}>
        <BookingWidget
          widgetType={type}
          widgetOptions={JSON.parse(
            target.getAttribute('data-rc-search-widget-options'),
          )}
        />
      </div>
    </React.StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
